import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Wheat, Stethoscope, GraduationCap, Leaf, Coins, Lightbulb } from "lucide-react";
import SectionHeader from "@/components/common/SectionHeader";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { getImageUrl } from "@/lib/api";

const ICON_MAP = {
  "heart-handshake": HeartHandshake,
  "wheat": Wheat,
  "stethoscope": Stethoscope,
  "graduation-cap": GraduationCap,
  "leaf": Leaf,
  "coins": Coins,
  "lightbulb": Lightbulb,
};

export default function Programs() {
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    api.get("/programs").then((r) => setPrograms(r.data.items || [])).catch(() => {});
  }, []);

  return (
    <section className="section-y bg-white" data-testid="home-programs">
      <div className="container-sf">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <SectionHeader
            eyebrow="Bidang Program Strategis"
            title="Tujuh"
            accentTitle="bidang dampak"
            description="Seluruh program Sauyunan dirancang dalam satu ekosistem yang saling terhubung — kemanusiaan, pangan, kesehatan, pendidikan, lingkungan, ekonomi, dan inovasi."
          />
          <Link to="/program" className="btn-outline shrink-0" data-testid="programs-see-all">
            Lihat Semua Program <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {programs.slice(0, 6).map((p, idx) => {
            const Icon = ICON_MAP[p.icon] || HeartHandshake;
            const accent = p.color === "accent";
            return (
              <Link
                key={p.slug}
                to={`/program/${p.slug}`}
                className="card-sf overflow-hidden group flex flex-col"
                data-testid={`program-card-${p.slug}`}
              >
                <div className="relative aspect-[4/2.6] overflow-hidden bg-slate-100">
                  <img
                    src={getImageUrl(p.hero_image)}
                    alt={p.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className={`absolute top-4 left-4 h-11 w-11 rounded-xl flex items-center justify-center text-white shadow-lg ${accent ? "bg-[var(--brand-orange)]" : "bg-[var(--brand-blue)]"}`}>
                    <Icon className="h-5 w-5" />
                  </div>
                  <div className="absolute top-4 right-4 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-slate-700">
                    0{idx + 1}
                  </div>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">{p.category}</div>
                  <h3 className="text-xl font-bold text-slate-900 leading-tight">{p.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-3">{p.short_description}</p>
                  <div className="mt-5 pt-4 border-t border-slate-100 flex items-center justify-between">
                    <span className="text-xs text-slate-500">{p.sub_programs?.length || 0} sub-program</span>
                    <span className="text-sm font-semibold text-[var(--brand-blue)] flex items-center gap-1 group-hover:text-[var(--brand-orange)] transition">
                      Selengkapnya <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-1 transition" />
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
